
import Vue from 'vue'
import Component from 'vue-class-component';
import EventBus from './../../eventBus'
import UserProVisioning from "@/mixins/userProvisioning"
import { Mixins } from 'vue-property-decorator';
import nptSettings from './npt/npt-settings/nptSettings.vue'

@Component({
    components: {
      'npt-settings': nptSettings
    },
  })
export default class Operations extends Mixins(UserProVisioning) {
    // DATA    
    selectedDepartment: any = "ALL"
    activeItem: any = null
    view: number = 0
    search: string = ''
    error: string = ''
    activeScreen: string = 'loading'
    loadingMessage: string = 'Loading Well Activities'
    loadingTitle: string = 'Loading...'
    deletePromptProperty: boolean = false
    successMessage: string = ''
    additionalSuccessMessage = ''
    loader: boolean = true
    selectedRowsNPT: { name: string; id: string }[] = []
    selectedRowsWellOps: { name: string; id: string }[] = []
    selectAllNPT: boolean = false
    selectAllWellOps: boolean = false
    canDeleteMultiple: boolean = false;
    // fieldsNpt: Array<any> = [
    //     { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
    //     { key: 'serial', label: 'S/N', sortable: false },
    //     { key: 'name', label: "Name", sortable: true },
    //     { key: 'nptRef', label: "Ref" },
    //     { key: 'rootCause', label: "Root Cause" },
    //     { key: 'associatedCause', label: "Associated Cause" },
    //     { key: 'button', label: "Actions" },
    // ]

    setNPTDeleteOption(option: any) {
        this.selectAllNPT = option.nptAllSetting;
        this.selectedRowsNPT = option.nptAllSettingsRows;
    }

    toggleSelectAllNPT() {
        if (!this.selectAllNPT) {
            this.selectedRowsNPT = this.allNpt.map((npt: any) => ({ id: npt.id, name: npt.name }))
        } else {
            this.selectedRowsNPT = []
        }
    }
    toggleSelectAllWellOps() {
        if (!this.selectAllWellOps) {
            this.selectedRowsWellOps = this.getWellOperations.map((operation: any) => ({ id: operation.id, name: operation.name }))
        } else {
            this.selectedRowsWellOps = []
        }
    }

    disableActivitiesDelete(item:any){
        let foundActivities = this.allProjects.find((project:any) => {
            if (project.activities && project.activities !== null && project.activities.length) {
                return project.activities.some((activity: any) => {
                    if (activity && activity !== null) {
                        return String(activity.wellActivity.id) == String(item.id) 
                    }
                    return null
                })
            }
            return null;
        })
        if (foundActivities && foundActivities !== '' && foundActivities != null) {
            return true
        }else {
            return false
        }
    }

    disableNPTDelete(item:any){
        let foundProjectClass = this.allReports().find((report:any) => {
            if (report.activityLog && report.activityLog.length) {
                return report.activityLog.some((x: any) => x.npt.nptOperationId == item.id);
            }
            return null;
        })
        if (foundProjectClass && foundProjectClass !== '' && foundProjectClass != null) {
            return true
        }else {
            return false
        }
    }

    get fields(){
       if(this.canWriteBudgetSettings){
            return  [
                { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
                { key: 'serial', label: 'S/N', sortable: false },
                { key: 'name', label: "Operation Name", sortable: true },
                { key: 'department', sortable: 'true' }, 'SampleDisplay',
                { key: 'button', label: "Actions" }
            ]
        }
         return  [
            { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
            { key: 'serial', label: 'S/N', sortable: false },
            { key: 'name', label: "Operation Name", sortable: true },
            { key: 'department', sortable: 'true' }, 'SampleDisplay',
                    // { key: 'numberOfDependentProjects', label: 'No of Dependent Projects'},
        ];
    }

    get fieldsNpt(){
       if(this.canWriteBudgetSettings){
            return  [
                { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
                { key: 'serial', label: 'S/N', sortable: false },
                { key: 'nptCategory', label: "NPT Category" },
                { key: 'rootCause', label: "Root Cause" },
                { key: 'button', label: "Actions" },
            ]
        }
         return  [
            { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
            { key: 'serial', label: 'S/N', sortable: false },
            { key: 'nptCategory', label: "NPT Category" },
            { key: 'rootCause', label: "Root Cause" },
        ];
    }

    // COMPUTED PROPERTIES
    get allProjects() {
        return this.$store.getters['projectModule/getAllProjects']
    }
    get allReports() {
        return this.$store.getters['DailyReportModule/getAllReports']
    }
    get getWellOperations() {
        const wellOps = this.selectedDepartment == "ALL" ? this.$store.getters['wellactivitiesModule/getWellOperations'] : this.$store.getters['wellactivitiesModule/getWellOperations'].filter((w: any) => w.departmentId == this.selectedDepartment);
        return wellOps.sort((a: any, b: any) => {
            const itemA = (a.name || '').toString().toLowerCase().trim();
            const itemB = (b.name || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }
    get activityTypes() {
        return this.$store.state.wellactivitiesModule.activityTypes
    }
    get getDepartmentById() {
        return this.$store.getters['departmentModule/getDepartmentById']
    }
    get fillteredDepartments() {
        return this.$store.getters['departmentModule/fillteredDepartments']
    }
    get allNpt() {
        return this.$store.getters['nptModule/getAllNpt']
    }

    get departmentOption() {
        return this.$store.getters["departmentModule/getDepartmentOptions"]
    }


    // VUEX METHODS AND MUTATIONS
    getWellActivities() {
        return this.$store.dispatch('wellactivitiesModule/getWellActivities')
    }

    getDepartments() {
        return this.$store.dispatch('departmentModule/getDepartments')
    }

    update(item: any, pathString: string) {
        this.activeItem = item;
        this.$router.push({ path: pathString, query: { id: item.id } })
    }

    promptDelete(item: any) {
        this.activeItem = item;
        this.deletePromptProperty = true
    }

    searchValue(e: any) {
        this.search = e
    }

    getWellOpsToDelete () {
        const names = this.selectedRowsWellOps.map(row => row.name);

        let formattedNames = '';

        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedRowsWellOps.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} well operation${remainingCount > 1 ? 's' : ''}`;
        }
    }
    
    getNptOpsToDelete () {
        const names = this.selectedRowsNPT.map(row => row.name);

        let formattedNames = '';

        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedRowsNPT.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} NPT${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDelete() {
        if (this.view === 0) {
            const isMultipleDelete = this.selectedRowsWellOps.length;
            this.activeScreen = 'loading'
            this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these activities' : 'this activity'}`
            this.loadingTitle = 'Deleting...'
            EventBus.$emit('activeScreen', this.activeScreen)

            const payload = isMultipleDelete ? this.selectedRowsWellOps.map(row => row.id) : [this.activeItem.id]
            this.$store.dispatch('wellactivitiesModule/deleteWellActivity', payload)
                .then((res: any) => {
                    this.activeScreen = 'successNoBack'
                    EventBus.$emit('activeScreen', this.activeScreen)
                    this.additionalSuccessMessage = `${isMultipleDelete ? 'These Activities': 'This Activity'} will no longer be available`
                    this.successMessage = `${isMultipleDelete ? this.getWellOpsToDelete() : this.activeItem.name} Deleted Successfully`
                    this.selectedRowsWellOps = []
                    this.deletePromptProperty = false
                })
                .catch((error: any) => {
                    this.activeScreen = 'error'
                    EventBus.$emit('activeScreen', this.activeScreen)
                    this.error = error.message
                    this.deletePromptProperty = false
                })
        } else {
            const isMultipleDelete = this.selectedRowsNPT.length;
            this.activeScreen = 'loading'
            this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these NPT operations' : 'this NPT operation'}`
            this.loadingTitle = 'Deleting...'
            EventBus.$emit('activeScreen', this.activeScreen)

            const payload = isMultipleDelete ? this.selectedRowsNPT.map(row => row.id) : [this.activeItem.id]
            this.$store.dispatch('nptModule/deleteNPTOperationAction', payload).then(response => {
                this.activeScreen = 'successNoBack'
                this.additionalSuccessMessage = `${isMultipleDelete ? 'These NPT Operations': 'This NPT Operation'} will no longer be available`
                EventBus.$emit('activeScreen', this.activeScreen)
                this.successMessage = `${isMultipleDelete ? this.getNptOpsToDelete() : this.activeItem.name} Deleted Successfully`
                this.selectedRowsNPT = []
                this.deletePromptProperty = false
            }, error => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.message
                this.deletePromptProperty = false
            })
        }
    }

    // CREATED
    created() {
        this.activeScreen = 'loading';
        EventBus.$emit('activeScreen', this.activeScreen)
        if (this.allNpt.length <= 0) {
            this.$store.dispatch('nptModule/fetchNptOperation')
        }
        if (this.fillteredDepartments('').length === 0) {
            this.getDepartments()
        }
        if (this.getWellOperations.length == 0) {
            this.getWellActivities()
            this.activeScreen = 'main';
            EventBus.$emit('activeScreen', this.activeScreen)
            this.loader = false
        } else {
            this.activeScreen = 'main';
            EventBus.$emit('activeScreen', this.activeScreen)
            this.loader = false
        }
    }

    mounted() {
        if (this.allReports().length <= 0) {
            this.$store.dispatch('DailyReportModule/getAllReports')
        }
        this.$store.dispatch("projectModule/getAllProjects")
    }

    beforeDestroy() {
        window.localStorage.setItem('LastRoute', '')
    }
}
